import {
    EdgeLabelRenderer,
    getStraightPath,
    useInternalNode
} from '@xyflow/react';

import {getEdgeParams} from './utils.js';
import {useEdgeBuilder} from "../association-network-context.jsx";

function FloatingEdge({id, source, target, markerEnd, style, data, selected}) {
    const {setPanelOpened} = useEdgeBuilder();
    const sourceNode = useInternalNode(source);
    const targetNode = useInternalNode(target);

    if (!sourceNode || !targetNode)  return null;

    const {sx, sy, tx, ty} = getEdgeParams(sourceNode, targetNode);

    const [path, labelX, labelY] = getStraightPath({
        sourceX: sx,
        sourceY: sy,
        targetX: tx,
        targetY: ty,
    });

    const newObservation = () => {
        setPanelOpened("addEdge")
    }

    return (
        <>
            <path
                d={path}
                stroke="transparent"
                strokeWidth={12}
                fill="none"
                onDoubleClick={newObservation}
                style={{ cursor: 'pointer' }}
            />
            <path
                id={id}
                className="react-flow__edge-path"
                d={path}
                markerEnd={markerEnd}
                onDoubleClick={newObservation}
                fill="none"
                style={{ ...style }}
            />

            {
                data?.label &&
                <EdgeLabelRenderer>
                    <p onDoubleClick={newObservation} style={{transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`}}
                       className="absolute bg-[#cfcfcf] mb-0 p-[3px] rounded-[3px] text-[8px]">
                        {data.label}
                    </p>
                </EdgeLabelRenderer>
            }
        </>
    );
}

export default FloatingEdge;
